export default function getStoreName(data, params) {
  const store = data.find(({ store_id }) => store_id === params.store);

  return store !== undefined
    ? store.store_name
    : params.store;
}
